import DashboardComponent from '../../../../../components/Dashboard/DashboardComponent';
import i18next from 'i18next';
import DashboardLogo from '../../../../../components/Shared/Icons/DashboardLogo';
import permissions from '../../../../permissions';

const DASHBOARD_ROUTES_ROOT = {
  path: '/:currentAccountUuid/dashboard',
  exact: true,
  additional: {
    component: DashboardComponent,
    title: i18next.t('titles:dashboard'),
    protected: true,
    icon: DashboardLogo,
    permission: permissions.DASHBOARD_GET,
    disabledId: 'dashboard',
  },
};

export const DASHBOARD_ROUTES = {
  // ------- For child accounts ------
  // ...

  // ------- For current accounts ------
  root: DASHBOARD_ROUTES_ROOT,
};

